

















import {Mixins, Component} from "vue-property-decorator";
import UserMixin from '../../../mixins/UserMixin';
import {Participant as ParticipantModel} from "@api/models/meetings/Participant";
import UserIcon from "../../common/UserIcon.vue";
import {ParticipantStatuses} from "../../../api/enums/Meetings/ParticipantStatuses";

@Component({
    components: { UserIcon }
})
export default class Participant extends Mixins(UserMixin) {
    get statusClass() {
        return 'is-' + (this.user as ParticipantModel).status?.toLowerCase();
    }

    get tooltipText() {
        const status = (this.user as ParticipantModel).status?.toLowerCase();
        if (status == ParticipantStatuses.accepted) {
            return this.$t('program.invite accepted');
        }
        if (status == ParticipantStatuses.pending)  {
            return this.$t('program.invite sended');
        }
        if (status == ParticipantStatuses.declined) {
            return this.$t('program.invite declined');
        }
        return '';
    }
}
